import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteGutachtenStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteGutachtenStatusCommandService],
  exports: []
})
export class DeleteGutachtenStatusCommandServiceModule { }
